import { ColoringPencil } from 'ui/icons/ai/ColoringPencil';
import {
  StyledDropdownErrorTitle,
  StyledDropdownErrorMessage,
  CopyAssistDropdownErrorWrapper,
} from 'modules/ai/copyAssist/components/styles';

export const CopyAssistDropdownError = () => {
  return (
    <CopyAssistDropdownErrorWrapper data-test="copy-assist-snag-error">
      <div>
        <ColoringPencil />
      </div>
      <StyledDropdownErrorTitle>{"We've hit a snag."}</StyledDropdownErrorTitle>
      <StyledDropdownErrorMessage>{'Try again in a few seconds'}</StyledDropdownErrorMessage>
    </CopyAssistDropdownErrorWrapper>
  );
};
